// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 3.5H1.5V7.81818H11V3.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.5 9.81818V14.1818H11V9.81818H1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.5 16.1818V20.5H11V16.1818H1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 20.5H22.5V16.1818H13V20.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 14.1818V9.81818H13V14.1818H22.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 7.81818V3.5H13V7.81818H22.5Z"}}]};

const Table2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-2-filled',
    ref,
    icon: element,
  },
));

Table2FilledIcon.displayName = 'Table2FilledIcon';

export default Table2FilledIcon;
